<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>مكونات التصنيع</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
              هنا يتم عرض جميع مكونات التصنيع
              <div class='pull-left' style='padding=0px'>
                <button @click='showForm(0)' type='button' class='btn btn-outline btn-primary btn-sm ' style='padding:3px;width: 80px' data-toggle='modal' data-target='#myModal'>
                  <b>  إضافة جديد </b>
                </button>
              </div>
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
              <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                <thead>
                  <tr>

                    <th style='text-align: center'>المنتج</th>
                    <th style='text-align: center'>الصنف</th>
                    <th style='text-align: center'>الكمية</th>
                    <th style='text-align: center'>الاجراء</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class='odd gradeX' v-for='record in records' :key='record.id'>

                    <td align='center'>{{record.product_name}}</td>
                    <td align='center'>{{record.item_name}}</td>
                    <td align='center'>{{record.quantity}}</td>
                    <td align='center'>
                      <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                      <button @click='deleteData(record.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                      <button @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>تعديل</button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- Modal -->
    <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
      <div class='modal-dialog  modal-lg'>
        <div class='modal-content'>
          <div class='modal-header'>
            <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
            <h4 class='modal-title' id='myModalLabel'>{{title}}</h4>
          </div>
          <form role='form'>
            <div class='modal-body'>
              <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='alert alert-success alert-dismissable' v-if='successShow'>
                {{success}}
              </div>
              <fieldset>
                <div class='col-lg-6 col-md-6 col-sm-6' style='padding:5px;'>
                  <label>المنتج:</label>
                  <select class="form-control" style="padding: 0px" v-model="record.product_id">
                    <option v-for="contractItem in contractItems" v-bind:key="contractItem.id" v-bind:value="contractItem.id">
                      {{ contractItem.item }}
                    </option>
                  </select>
                </div>
                <div class='col-lg-6 col-md-6 col-sm-6' style='padding:5px;'>
                  <label>الصنف:</label>
                  <select class="form-control" style="padding: 0px" v-model="record.item_id">
                    <option v-for="contractItem in componentsItems" v-bind:key="contractItem.id" v-bind:value="contractItem.id">
                      {{ contractItem.item }}
                    </option>
                  </select>
                </div>
                <div class='form-group col-lg-6 col-sm-6'>
                  <label>الكمية:</label>
                  <input v-model='record.quantity' class='form-control' name='quantity' type='text'>
                </div>
              </fieldset>
            </div>
            <div class='modal-footer'>
              <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
              <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
              <button @click='saveData' type='button' class='btn btn-primary'>حفظ</button>
            </div>
          </form>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- /.container-fluid -->
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'manufacturing_components',
  data () {
    return {
      validationErrors: '',
      records: {},
      record: {},
      items: '',
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      title: ''
    }
  },
  created () {
    this.items = JSON.parse(localStorage.getItem('Items'))
    this.GetData()
  },
  computed: {
    contractItems () {
      return this.items.filter(item => item.is_contract === 1)
    },
    componentsItems () {
      return this.items.filter(item => item.is_contract === 0)
    }
  },
  methods: {
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getManufacturingComponents', {
        token: localStorage.getItem('token')
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      if (recID === 0) {
        this.title = 'إضافة سجل جديد'
        this.record = {'id': 0, 'product_id': '', 'item_id': '', 'quantity': ''}
      } else {
        this.title = 'تعديل بيانات سجل'
        this.record = recID
      }
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveManufacturingComponents', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        product_id: this.record.product_id,
        item_id: this.record.item_id,
        quantity: this.record.quantity
      })
        .then(res => {
          this.isLoadingSave = false
          if (this.record.id === 0) {
            this.records.push(res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          } else {
            let i = this.records.map(record => record.id).indexOf(this.record.id)
            this.records.splice(i, 1, res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          }
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'deleteManufacturingComponents', {
        token: localStorage.getItem('token'),
        id: recID
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(recID)
          this.records.splice(i, 1)
          this.isLoadingDelete = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.error = err.message
          this.isLoadingDelete = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/company/ManufacturingComponents.vue